import { PdfAsset } from '../pdfs/pdf-asset-model';
import { FolderBreadcrumb } from './folder-breadcrumb.model';
import { AppTeamUtil } from '../../core/app-team-util';

export class Folder
{
    Breadcrumbs?: FolderBreadcrumb[];
    CategoryIds: number[] = [];
    Date?: Date;
    Description?: string;
    Folders: Folder[] = [];
    HasSubFolders = false;
    Id!: number;
    IsPublished = false;
    Name!: string;
    ParentId!: number;
    Pdfs: PdfAsset[] = [];
    // Selected = false; // For UI selection purposes only

    constructor(json: any = null)
    {
        if (json)
        {
            Object.assign(this, json);

            this.Date = AppTeamUtil.convertApiDateStringToDate(json.Date)!;
            if (json.Breadcrumbs != null) this.Breadcrumbs = json.Breadcrumbs.map((item: any) => new FolderBreadcrumb(item));
            if (json.Folders != null) this.Folders = json.Folders.map((item: any) => new Folder(item));
            if (json.Pdfs != null) this.Pdfs = json.Pdfs.map((item: any) => new PdfAsset(item));
            if (this.CategoryIds == null) this.CategoryIds = [];
            this.sortPdfs();
        }
    }

    addFolder(folder: Folder): void
    {
        this.Folders.push(folder);
        this.sortFolders();
    }

    private sortFolders(): void
    {
        this.Folders = this.Folders.sort((f1: Folder, f2: Folder) => f1.Name.localeCompare(f2.Name, undefined, { sensitivity: 'base'}));
    }

    addPdf(pdf: PdfAsset): void
    {
        this.Pdfs.push(pdf);
        this.sortPdfs();
    }

    private sortPdfs(): void
    {
        this.Pdfs = this.Pdfs.sort((pdf1: PdfAsset, pdf2: PdfAsset) => pdf1.simpleName.localeCompare(pdf2.simpleName, undefined, { sensitivity: 'base'}));
    }
}
